import _objectWithoutProperties from "C:/Users/goss/Documents/SVN/cp-ctnet-public/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { createTileLayerComponent, updateGridLayer, withPane } from '@react-leaflet/core';
import { TileLayer as LeafletTileLayer } from 'leaflet';
export var TileLayer = createTileLayerComponent(function createTileLayer(_ref, context) {
  var url = _ref.url,
      options = _objectWithoutProperties(_ref, ["url"]);

  return {
    instance: new LeafletTileLayer(url, withPane(options, context)),
    context: context
  };
}, updateGridLayer);